import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsPage.css';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-page">
      <div className="terms-container">
        <button className="terms-back-button" onClick={() => navigate('/')}>
          ← Back to Map
        </button>

        <h1>Privacy Policy</h1>

        <div className="terms-content">
          <p className="last-updated">Last updated: January 2025</p>

          <section>
            <h2>Overview</h2>
            <p>
              This Privacy Policy describes how anicha.earth collects, uses, and protects information when you use our web app and APIs.
            </p>
          </section>

          <section>
            <h2>Information We Collect</h2>
            <p>We collect the minimum data needed to operate and improve the service:</p>
            <ul>
              <li>Technical data such as browser type, device information, and IP address.</li>
              <li>Usage analytics about how the app is used (pages viewed, interactions).</li>
              <li>Optional contact details when you email us or request API access.</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Information</h2>
            <p>Information is used to:</p>
            <ul>
              <li>Operate, maintain, and improve the service.</li>
              <li>Monitor reliability, performance, and security.</li>
              <li>Communicate with you about support or product updates when requested.</li>
            </ul>
          </section>

          <section>
            <h2>Data Sharing</h2>
            <p>
              We do not sell personal data. We may share limited data with trusted providers that help us run analytics or infrastructure, under strict confidentiality.
            </p>
          </section>

          <section>
            <h2>Data Retention</h2>
            <p>
              We retain data only as long as necessary for the purposes described above or as required by law. You can request deletion of contact information you have provided.
            </p>
          </section>

          <section>
            <h2>Cookies</h2>
            <p>
              We may use cookies or similar technologies for session management and analytics. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2>Security</h2>
            <p>
              We use industry-standard measures to protect data in transit and at rest, but no system is entirely secure. Please report any concerns to the contact below.
            </p>
          </section>

          <section>
            <h2>Changes</h2>
            <p>
              We may update this policy from time to time. Changes are effective upon posting. Continued use of the service constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              Questions or requests? Email us at <a href="mailto:konstantin@anicha.earth">konstantin@anicha.earth</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
